module.exports = __webpack_public_path__ + "static/me.57269161.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/me.jpg
// module id = 1056
// module chunks = 35783957827783